import { formStateAtom } from './state.atoms'
import { validationResultsAtom } from './validation.atoms'

export { CreateLineItemGroup } from './CreateLineItemGroup'
export const createLineItemGroupAtoms = [formStateAtom, validationResultsAtom]
